/**
 * Estimated reading time in minutes for Sanity portable-text content.
 * Extracted from the help article page so blog and help share one implementation.
 */

export interface ReadingTimeBlock {
  _type?: string;
  children?: Array<{ text?: string }>;
}

export function calculateReadingTime(blocks: ReadingTimeBlock[] | undefined | null): number {
  if (!blocks?.length) return 0;

  const text = blocks
    .map((block) => {
      if (block._type === "block" && block.children) {
        return block.children.map((child) => child.text || "").join(" ");
      }
      return "";
    })
    .join(" ");

  const wordsPerMinute = 200;
  const wordCount = text.split(/\s+/).filter((word) => word.length > 0).length;
  return Math.ceil(wordCount / wordsPerMinute);
}
